// <Rules> — the 游戏规则 overlay (#rules), opened by the classic showRules() window fn. PURE
// function of `app` (the rules text is static, so it takes no live state — but it stays a
// component for DRY/consistency with the other overlays). Emits the SAME .overlay/.sheet
// scaffold + data-action="close-rules" as the old imperative string so document-level click
// delegation + the smoke grep contract stay green. See PREACT-MIGRATION.md.
import { html, OverlaySheet, Banner, t } from '../shared.js';

// Each rule is a pair of STR keys (`rules.<topic>.h` heading / `.b` body). Bodies contain inline
// <b>…</b> emphasis, so they're pre-built HTML rendered via dangerouslySetInnerHTML (the strings
// are author-controlled STR-table literals, no user input — same trust level as the old markup).
const RULES: string[] = ['roles', 'word', 'turns', 'vote', 'pk', 'ghost', 'win', 'wrap'];

export function Rules({ app }: { app: AppState }) {
  const footer = html`<div class="row" style="margin-top:12px"><button class="yellow" data-action="close-rules">${t('rules.ok')}</button></div>`;
  return html`<${OverlaySheet} footer=${footer} x="close-rules">
      <${Banner} title=${t('rules.title')} sub=${t('rules.sub')} size="clamp(26px,8vw,42px)" />
      <div class="rules-list">
        ${RULES.map((k: string) => html`<div class="rule-item"><b>${t(`rules.${k}.h`)}</b><div class="small" dangerouslySetInnerHTML=${{ __html: t(`rules.${k}.b`) }}></div></div>`)}
      </div>
    </${OverlaySheet}>
  `;
}
